import { Box, Stack, Typography } from '@mui/material';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Navigate, useNavigate } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';

import usePageTitle from 'portal/src/navigation/usePageTitle';
import useAuth from 'portal/src/auth/useAuth';
import ChangePasswordForm from 'portal/src/components/systemAdministration/Form/User/PasswordForms/ChangePasswordForm';
import { AccountProviderIds } from 'portal/src/constants/AccountProviderIds';

export default function ChangeExpiredPassword() {
  usePageTitle('Change Password');

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { isAuthenticated, logout, refreshUser, verifyUserAccountProvider } =
    useAuth();

  const {
    data: userAccountProvider,
    isError: isAcctProviderError,
    isFetching: isFetchingAcctProvider,
  } = useQuery({
    queryKey: ['userAccountProvider'],
    queryFn: async () => await verifyUserAccountProvider(),
    initialData: {},
    enabled: isAuthenticated(),
  });

  if (!isAuthenticated()) {
    return <Navigate to={BASE.AUTH.LOGIN} replace />;
  }

  const handleCancel = async () => {
    await logout();
    navigate(BASE.AUTH.LOGIN, { replace: true });
  };

  const handleSaveChange = async () => {
    await queryClient.clear();
    await refreshUser();
    navigate('/', { replace: true });
  };

  const renderForm = () => {
    if (isFetchingAcctProvider || !isAuthenticated()) {
      return null;
    }

    if (isAcctProviderError) {
      <Typography color="error">
        An error occurred, please try again later
      </Typography>;
    }

    return (
      <ChangePasswordForm
        onCancel={handleCancel}
        onSaveChange={handleSaveChange}
        providerId={userAccountProvider.providerId}
      />
    );
  };

  return (
    <Stack sx={{ m: 5, alignItems: 'center' }}>
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        <Typography variant="h3" sx={{ textAlign: 'center' }}>
          Your password has expired
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          For your security, please set a new password to continue.
        </Typography>
      </Stack>
      <Box sx={{ marginTop: 2 }}>{renderForm()}</Box>
    </Stack>
  );
}
